import _ from "lodash";

export default {
  menuStatus(state) {
    return function(params) {
      return state.menuStatus[params];
    };
  },

  getOffset(state) {
    return state.offset;
  },

  ///  get item from any list(key) using value(val(id...))
  getFromList: function(state) {
    return function(params) {
      if (!_.get(state, params.key) || !_.get(params, "val")) return {};
      params.field = params.field ? params.field : "id";

      for (let i in _.get(state, params.key)) {
        if (
          _.get(state, params.key + "." + i + "." + params.field) == params.val
        )
          return JSON.parse(JSON.stringify(_.get(state, params.key + "." + i)));
      }

      return {};
    };
  },

  getComponent: function(state) {
    return function(params) {
      let data;
      for (let i in state.current_content.secondary) {
        if (
          state.current_content.secondary[i].conf.selectedComponent === params
        ) {
          data = state.current_content.secondary[i];
        }
      }
      return data;
    };
  },

  getList: function(state) {
    return function(params) {
      if (!_.get(state, params.key)) return {};
      return JSON.parse(JSON.stringify(_.get(state, params.key)));
    };
  },

  filterListBy: function(state) {
    return function(params) {
      if (!_.get(state, params.key) || !_.get(params, "val")) return {};
      params.field = params.field ? params.field : "id";

      const ret = [];
      for (const i in _.get(state, params.key)) {
        if (
          _.get(state, params.key + "." + i + "." + params.field) == params.val
        )
          ret.push(
            JSON.parse(JSON.stringify(_.get(state, params.key + "." + i)))
          );
      }

      return ret;
    };
  },

  getStateItem: function(state) {
    return function(params) {
      if (!_.get(state, params.key)) return false;
      return JSON.parse(JSON.stringify(_.get(state, params.key)));
    };
  },

  /// get single url for inner pages
  getSingleUrl(state, getters) {
    return function(params, currentPage) {
      if (!parseInt(_.get(params, "id"))) return "#";
      let singlePath = "/singleview/" + params.id + "-" + params.slug;

      /// if currentPage==1 means open single template under current menu
      if (currentPage == 1) {
        return state.selected_menu.full_url + "" + singlePath;
      }

      let menuPage = {};

      if (parseInt(params.singlePageRoute)) {
        /// search if set single menu for exact content
        menuPage = _.find(state.indx.menus, {
          id: parseInt(params.singlePageRoute)
        });

        // console.log(params.singlePageRoute);
      } else if (
        parseInt(
          _.get(state.indx, [
            "contentTypes",
            params.content_type,
            "settings",
            "defaultSingleRoute"
          ])
        )
      ) {
        /// search if set default single menu route for content type
        menuPage = _.find(state.indx.menus, {
          id: parseInt(
            state.indx.contentTypes[params.content_type].settings
              .defaultSingleRoute
          )
        });

        // console.log(state.indx.contentTypes[params.content_type].settings.defaultSingleRoute);
      }

      let ret = "";

      if (menuPage.full_url) {
        /// if found single menu route open single page under it
        ret = menuPage.full_url + "" + singlePath;
      } else {
        /// if not found any single routes open single page under current route
        ret = state.selected_menu.full_url + "" + singlePath;
      }

      return ret;
    };
  },

  /// recursive method to find desired template inside parent id
  searchSecondaryTemplate(state, getters) {
    return function(parentId, defaultSingleTemplate, defaultListTemplate) {
      let siblings = _.filter(state.indx.menus, { pid: parentId });

      for (let i in siblings) {
        // console.log(parentId, _.get(siblings[i], ['secondary_content','template']), defaultSingleTemplate, defaultListTemplate);
        if (
          _.get(siblings[i], ["secondary_content", "template"]) &&
          (_.get(siblings[i], ["secondary_content", "template"]) ==
            defaultSingleTemplate ||
            _.get(siblings[i], ["secondary_content", "template"]) ==
              defaultListTemplate)
        ) {
          return siblings[i];
        }

        let ret = getters.searchSecondaryTemplate(
          siblings[i].id,
          defaultSingleTemplate,
          defaultListTemplate
        );
        if (ret.id) return ret;
      }

      return false;
    };
  },

  /// get taxonomy term url under current url
  getCategoryUrl(state) {
    return function(categoryId, currentPage) {
      if (!parseInt(categoryId)) return "#";
      let singlePath = "/content-category/" + categoryId;

      // if (currentPage){
      //   return state.selected_menu.full_url+''+singlePath;
      // }

      return state.selected_menu.full_url + "" + singlePath;
    };
  },

  getContentRelatedMenu(state) {
    return function(contentId) {
      for (let i in state.indx.menus) {
        if (
          _.get(state.indx.menus[i], ["primary_content", "page"]) == contentId
        )
          return state.indx.menus[i].full_url;
      }
      return false;
    };
  },

  getBackgroundTone: function(state) {
    return function(evenOdd) {
      let startDark = _.includes(
        _.get(state.selected_menu, "configs"),
        "start-zebra-darker"
      )
        ? true
        : false;

      if (evenOdd === 1 && startDark) return "dark";
      if (evenOdd === 0 && !startDark) return "dark";
      return "light";
    };
  }
};
